import { useEffect } from "react";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { mediaUrl } from "@/lib/api";

export const Lightbox = ({ items, index, onClose, onIndex }) => {
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") onIndex((index + 1) % items.length);
      if (e.key === "ArrowLeft") onIndex((index - 1 + items.length) % items.length);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [index, items.length, onClose, onIndex]);

  if (index == null || !items[index]) return null;
  const m = items[index];
  return (
    <div data-testid="lightbox" className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center" onClick={onClose}>
      <button data-testid="lightbox-close" onClick={onClose} className="absolute top-5 right-5 text-white/80 hover:text-white"><X size={28} /></button>
      {items.length > 1 && (
        <>
          <button data-testid="lightbox-prev" onClick={(e) => { e.stopPropagation(); onIndex((index - 1 + items.length) % items.length); }} className="absolute left-4 sm:left-8 text-white/80 hover:text-white"><ChevronLeft size={40} /></button>
          <button data-testid="lightbox-next" onClick={(e) => { e.stopPropagation(); onIndex((index + 1) % items.length); }} className="absolute right-4 sm:right-8 text-white/80 hover:text-white"><ChevronRight size={40} /></button>
        </>
      )}
      <div className="max-w-[90vw] max-h-[85vh]" onClick={(e) => e.stopPropagation()}>
        {m.media_type === "video" ? (
          <video src={mediaUrl(m.url)} controls autoPlay className="max-w-[90vw] max-h-[85vh] rounded-lg" />
        ) : (
          <img src={mediaUrl(m.url)} alt="" className="max-w-[90vw] max-h-[85vh] object-contain rounded-lg" />
        )}
      </div>
      <span className="absolute bottom-5 text-white/70 text-sm">{index + 1} / {items.length}</span>
    </div>
  );
};
